import {InputTextV2} from '@prtimes-basis/input';
import {FormField, useFormField} from '../../../form-field';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';

export function DepartmentField() {
  return (
    <FormField.Root name='billingInfo.department'>
      <Body />

      <FormField.Error />
    </FormField.Root>
  );
}

function Body() {
  const {fieldProps} = useFormField();

  return (
    <InputTextV2
      wrapperClassName={companyRegistrationPageStyles.sizedInput}
      {...fieldProps}
    />
  );
}
